import React, { useEffect, useState } from "react";

import * as S from "../styles";
import { BoldTitle, FH, Text, TextDate, Title } from "../../../main-styles";
import Stepper from "../../../../components/Stepper";
import { useNavigate, useParams } from "react-router";
import WhiteBox from "../../../../components/WhiteBox";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoin } from "@fortawesome/pro-light-svg-icons";
import { useTheme } from "styled-components";
import Timeline from "../../../../components/Timeline";
import { Spinner } from "reactstrap";
import { getOrderById } from "../../../../api/orders";

const MOCK_PEDIDO = {
  id: 1,
  status: "Em separação",
  data: "2025-06-01",
  valor: 1000,
  timeline: [
    {
      status: "Solicitado",
      data: "2025-06-01 08:30",
    },
    {
      status: "Criado",
      data: "2025-06-01 08:42",
    },
    {
      status: "Faturado",
      data: "2025-06-01 09:00",
    },
    {
      status: "Em separação",
      data: "2025-06-01 09:00",
    },
    {
      status: "Separado",
      data: "2025-06-01 10:00",
    },
  ],
  itens: [
    {
      id: 1,
      nome: "Caneca de Café",
      imagem: "/assets/produtos/image-0.png",
      quantidade: 22,
      valor: 500,
    },
    {
      id: 2,
      nome: "Canivete Suíço",
      imagem: "/assets/produtos/image-1.png",
      quantidade: 100,
      valor: 1000,
    },
  ],
};

function Detalhe() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    loadPedido();
  }, [id]);

  async function loadPedido() {
    setLoading(true);
    try {
      // Simulating an API call with a timeout
      // Replace this with your actual API call
      const response = await getOrderById(id);
      setData(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching order details:", error);
      // Handle error appropriately, e.g., show a notification|
    }
  }

  if (loading) {
    return (
      <S.Container>
        <Spinner />
      </S.Container>
    );
  }

  console.log("data", data);

  return (
    <S.Container>
      <Title onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
        Voltar
      </Title>
      <FH style={{ width: "100%", justifyContent: "space-between" }}>
        <BoldTitle>Pedido #{id}</BoldTitle>
      </FH>
      <S.DetalhesGrid>
        <S.DetalhesPedidoContainer>
          <WhiteBox>
            <FH style={{ width: "100%", justifyContent: "space-between" }}>
              <div>
                <Text>
                  Data de solicitação: {moment(data.created_at).format("DD/MM/YYYY")}
                </Text>
                <Text>
                  Data de Entrega:{" "}
                  {data.status !== "entregue" ? (
                    <b>PENDENTE</b>
                  ) : (
                    moment(data.delivery_date).format("DD/MM/YYYY")
                  )}
                </Text>
              </div>
              <FH>
                <Stepper step={data.current_status} size={10} />
              </FH>
            </FH>
            <br />
            <br />
            <Title>Itens do pedido</Title>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {data.itens.map((item) => (
                  <tr key={item.id}>
                    <td style={{ verticalAlign: "middle" }}>
                      <img
                        src={item.imagem}
                        style={{
                          height: 50,
                          width: 50,
                          borderRadius: 5,
                          marginRight: 10,
                          objectFit: "cover",
                          objectPosition: "center",
                        }}
                        alt="Produto"
                      />
                      {item.nome}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {item.quantidade}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <FontAwesomeIcon icon={faCoin} color={theme.primary} />{" "}
                      {item.valor}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    colSpan={2}
                    style={{ textAlign: "right", backgroundColor: "#d7d7d7" }}
                  >
                    <Text style={{ fontWeight: "bold", fontSize: 16 }}>
                      Valor total:
                    </Text>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      backgroundColor: "#d7d7d7",
                    }}
                  >
                    <FontAwesomeIcon icon={faCoin} color={theme.primary} />{" "}
                    {data.value}
                  </td>
                </tr>
              </tbody>
            </table>
          </WhiteBox>
        </S.DetalhesPedidoContainer>
        <S.TimeLineContainer>
          <WhiteBox>
            <Timeline items={data?.historico} />
          </WhiteBox>
        </S.TimeLineContainer>
      </S.DetalhesGrid>
    </S.Container>
  );
}

export default Detalhe;
